module.exports = __webpack_public_path__ + "static/media/10.eb5dfd05.jpg";